import React, { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CircleIcon from "@mui/icons-material/Circle";
import { useMutation } from "react-query";
import {
  GetLegacyContractsResponse,
  GetLoanInfoRequest,
} from "../../models/loan.model";
import { GetLegacyContracts } from "../../services/loan.service";
import { ApiResultModel } from "../../models/common.model";

interface props {
  dataFlag: string,
  parsLizverData: GetLegacyContractsResponse[]
}

export default function ParsLisver({ dataFlag, parsLizverData }: props) {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  // let nationalCode = new GetLoanInfoRequest();
  // nationalCode.customerNationalCode = props.nationalCode;
  // const {
  //   mutateAsync: GetLegacyContractsMutation,
  //   isLoading: isMutatin,
  // } = useMutation(GetLegacyContracts, {
  //   onSuccess: (data: ApiResultModel<GetLegacyContractsResponse[]>) => {
  //     if (data.isSuccess) {
  //       if (data.data.length > 0) {
  //         setData(data.data);
  //       } else {
  //         setDataFlag("null");
  //       }
  //     } else if (!data.isSuccess) {
  //       setDataFlag("isNotSuccess");
  //     }
  //   },
  // });
  useEffect(() => {
    // GetLegacyContractsMutation(nationalCode);
  }, []);

  function handelCollapse() {
    setExpanded(!isExpanded);
  }

  if (parsLizverData) {
    return (
      <Box
        sx={{
          margin: "1.9vh",
          direction: "rtl",
          overflowX: "none",
          border: "2px solid #FB8C00",
        }}
      >
        <div
          className="boxView  borderCOlor"
          style={{ background: "#F6F8F9", padding: "10px" }}
        >
          <div
            onClick={handelCollapse}
            style={{
              backgroundColor: "#FB8C00",
              height: "4vh",
              marginBottom: "-1.4vh",
              marginRight: "-11px",
              marginLeft: "-11px",
              marginTop: "-11px",
            }}
            className="centerVertical"
          >
            <span
              style={{
                backgroundColor: "#FB8C00",
                color: "#fff",
                fontSize: "16px",
                marginRight: "2vh",
              }}
            >
              <NotificationImportantOutlinedIcon /> این متقاضی دارای پرونده
              تسهیلات باز می باشد &nbsp;
            </span>
            {isExpanded ? (
              <ArrowDropUpIcon style={{ color: "#fff" }} />
            ) : (
              <MoreHorizIcon style={{ color: "#fff" }} />
            )}
          </div>
          <section {...getCollapseProps()}>
            <br />
            <br />

            {parsLizverData!.map((item: any) => (
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                style={{
                  background: "#F6F8F9",
                  color: "#9AAFC4",
                  width: "100%",
                }}
              >
                <Grid item xs={6} style={{ fontSize: "15px" }}>
                  <CircleIcon
                    style={{ color: "#FB8C00", width: "7px", height: "7px" }}
                  />
                  &nbsp; نام طرح:{" "}
                  <b style={{ color: "#34495E" }}>{item.subProtocolTitle}</b>
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  style={{
                    border: "1px solid #DAE0E4",
                    borderRadius: "3px",
                    //   width: "90%",
                    background: "#fff",
                    margin: "15px 25px",
                    padding: "4px 7px 7px 7px",
                  }}
                >
                  <Grid item xs={6} md={2} >
                    مبلغ:{" "}
                    <b style={{ color: "#34495E" }}>
                      {item.loanAmount.toLocaleString("fa")} ریال
                    </b>
                  </Grid>
                  <Grid item xs={6} md={2} >
                    شماره قرارداد:{" "}
                    <b style={{ color: "#34495E" }}>{item.contractNumber}</b>
                  </Grid>
                  <Grid item xs={6} md={4} >
                    تاریخ قرارداد:{" "}
                    <b style={{ color: "#34495E" }}>{item.contractDate}</b>
                  </Grid>
                  <Grid item xs={3} md={2} >
                    تعداد اقساط:{" "}
                    <b style={{ color: "#34495E" }}>{item.instalmentCount}</b>
                  </Grid>
                  <Grid item xs={3} md={2} >
                    فاصله اقساط:{" "}
                    <b style={{ color: "#34495E" }}>
                      {item.instalmentDistance}
                    </b>
                  </Grid>
                  {/* <Grid item xs={4} md={2} >
                    تاریخ قسط اول:{" "}
                    <b style={{ color: "#34495E" }}>
                      {item.firstInstalmentDate}
                    </b>
                  </Grid> */}
                </Grid>
              </Grid>
            ))}
          </section>
        </div>
      </Box>
    );
  } else if (dataFlag == "isNotSuccess") {
    return (
      <Box
        sx={{
          margin: "1.9vh",
          direction: "rtl",
          overflowX: "none",
          border: "2px solid #E57373",
        }}
      >
        <div
          className="boxView  borderCOlor"
          style={{ background: "#E57373", padding: "10px" }}
        >
          <div
            onClick={handelCollapse}
            style={{
              backgroundColor: "#E57373",
              height: "4vh",
              marginBottom: "-1.4vh",
              marginRight: "-11px",
              marginLeft: "-11px",
              marginTop: "-11px",
            }}
            className="centerVertical"
          >
            <span
              style={{
                backgroundColor: "#E57373",
                color: "#fff",
                fontSize: "16px",
                marginRight: "2vh",
              }}
            >
              <ReportGmailerrorredOutlinedIcon /> دریافت اطلاعات از "پارس
              لیزور" با خطا مواجه شد&nbsp;
            </span>
          </div>
        </div>
      </Box>
    );
  } else {
    return <></>;
  }
}

